import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@modules/auth/hooks/useAuth";

/**
 * RoleGuard (Outlet-based)
 * Assumes an AuthGuard is mounted higher in the tree.
 * Redirects to `fallback` if the user's role doesn't match.
 */
type Role = "sales" | "user";

type RoleGuardProps = {
  allowed: Role; // which role can see the nested routes
  fallback?: string; // where to send users who don't match
};

const RoleGuard = ({ allowed, fallback = "/" }: RoleGuardProps) => {
  const { user } = useAuth();

  // Defensive: if somehow no user here, kick to login
  if (!user) return <Navigate to="/" replace />;

  const isSales = Boolean(user.is_sale);
  const canAccess =
    (allowed === "sales" && isSales) || (allowed === "user" && !isSales);

  if (!canAccess) return <Navigate to={fallback} replace />;

  return <Outlet />;
};

export default RoleGuard;
